// vim: set ts=2 sts=2 sw=2 et:

import { MeetState } from "../../types/stateTypes";
import { PlatformRef } from "../types";

export const parsePlatformRef = (
  dayParam: string | undefined,
  platformParam: string | undefined,
): PlatformRef | null => {
  const day = Number(dayParam);
  const platformId = Number(platformParam);

  if (!Number.isInteger(day) || !Number.isInteger(platformId)) {
    return null;
  }
  if (day < 1 || platformId < 1) {
    return null;
  }

  return { day, platformId };
};

export const isValidPlatformRef = (meet: MeetState, platformRef: PlatformRef): boolean => {
  if (platformRef.day < 1 || platformRef.day > meet.lengthDays) {
    return false;
  }

  const platformsOnDay = meet.platformsOnDays[platformRef.day - 1];
  if (typeof platformsOnDay !== "number") {
    return false;
  }

  return platformRef.platformId >= 1 && platformRef.platformId <= platformsOnDay;
};
